import { useSelector } from "react-redux";
import { AppStore } from "../../store";
import { HomeProductsState } from "../../types/home-products";
import { selectHomeProductsState } from "./home-products.slice";

export const useGetHomeProductsState = () => {
  return useSelector<AppStore, HomeProductsState>(selectHomeProductsState);
};
